module.exports = __tmimport("~endpoint:{controller: \'box_office\', action: \'index\', box_office: \':name\'}");